import React from 'react';
import { BrowserRouter, Route, Redirect } from 'react-router-dom';
import { TaskDetails } from 'components/TaskDetails/TaskDetailsPage';
import IncidentDetailsPage from 'components/IncidentDetails/IncidentDetailsPage/IncidentDetailsPage';
import ManageAutomationPage from 'components/ManageAutomationPage/ManageAutomationPage';
import LoginPage from '../login/LoginPage';
// import LoginCallbackPage from '../login/LoginCallbackPage';
import { LoginCallbackPage } from '../login/LoginCallbackPage';
import ProtectedRoute from './ProtectedRoute';
import Bpmn from 'components/Bpmn/BpmnDiagram';
import QualityCheckPage from 'components/QualityCheck/QualityCheckPage';
import CompletedQualityCheck from 'components/QualityCheck/CompletedQualityCheck';
import UploadFilePage from 'components/QualityCheck/UploadFilePage';
import AddNewCodePage from 'components/QualityCheck/AddNewCodePage';
import AddNewSchedule from 'components/QualityCheck/AddNewSubmit';
import ManageSchedulePage from 'components/ManageSchedule/ManageSchedulePage';
import { CustomizedSteppers } from 'components/ManageSchedule/CustomizedSteppers';
import RunAutomata from 'components/RunAutomata/RunAutomataPage';
import completedRunAutomata from 'components/RunAutomata/CompletedRunAutomata';
import ExceptionRunAutomata from 'components/RunAutomata/ExceptionRunAutomata';
import ExecutionPerformance from 'components/Dashboards/ExecutionPerformanceDashboard/ExecutionPerformance';
import IncidentManagement from 'components/Dashboards/IncidentManagementDashboard/IncidentManagement';
import SLACompliance from 'components/Dashboards/SLADashboard/SLACompliance';
import HomePage from 'components/HomePage/HomePage';
import QueueEfficiency from 'components/Dashboards/QueueEfficiency';
import Analytics from 'components/Dashboards/Analytics';
import QueuePerformance from 'components/Dashboards/QueuePerformanceDashboard/QueuePerformance';
import AlertManagement from 'components/Dashboards/AlertManagementDashboard/AlertManagement';
import CreateRunAutomataPage from 'components/RunAutomata/CreateRunAutomata';
import NewHomeScreen from 'components/HomePage/NewHomeScreen';
import OldHomeScreen from 'components/HomePage/HomeScreen';
import SAPMonitoring from 'components/SAPMonitoring/SAPMonitoring';
import SAPMonitoringThree from 'components/SAPMonitoring/SAPMonitoringBackup';
import BillingReport from 'components/BillingReport/BillingReport';

function Router(props) {
    let workspace=props.workspace;

    return (
        <BrowserRouter>
            <div>
                <Route path="/" exact component={LoginPage} />
                <Route path="/login" exact component={LoginPage} />
                <Route path="/callback" exact component={LoginCallbackPage} />
                <ProtectedRoute path="/taskDetails" component={TaskDetails} />
                <ProtectedRoute path="/billingReport" component={BillingReport} />
             
                {/* <ProtectedRoute path="/manage_operations" component={ManageAutomationPage} /> */}

                {/* <ProtectedRoute path="/manage_operations" exact component={(props) => (
                    <ManageAutomationPage {...props} workspace={workspace} />
                )} /> */}
               <ProtectedRoute path="/manage_operations" exact workspace={workspace} component={ManageAutomationPage} />

                {/* <ProtectedRoute path="/IncidentDetails/:alertType/:incidentId" exact component={(props) => (
                    <IncidentDetailsPage {...props} workspace={workspace} />
                )} /> */}
                {/* <ProtectedRoute path="/UserIncidentDetails/:alertType/:incidentId" exact workspace={workspace} component={IncidentDetailsPage} /> */}
                {/* <ProtectedRoute path="/IncidentDetails/:alertType/:incidentId" exact workspace={workspace} component={IncidentDetailsPage} /> */}
                <ProtectedRoute path="/UserIncidentDetails" exact workspace={workspace} component={IncidentDetailsPage} />
                <ProtectedRoute path="/IncidentDetails" exact workspace={workspace} component={IncidentDetailsPage} />

                <ProtectedRoute path="/qualityCheck" exact component={QualityCheckPage} />
                <ProtectedRoute path="/qualityCheck/uploadFile" exact component={UploadFilePage} />
                <ProtectedRoute path="/qualityCheck/uploadFile_status" exact component={AddNewCodePage} />
                <ProtectedRoute path="/scheduler/scheduleCreated" exact component={AddNewSchedule} />
                <ProtectedRoute path="/qualityCheck/completedQualityCheck" exact component={CompletedQualityCheck} />
                <ProtectedRoute path="/homePage" exact component={NewHomeScreen} />
                <ProtectedRoute exact path="/automata" component={CreateRunAutomataPage} />
                {/* <ProtectedRoute exact path="/automata/createAutomata" component={CreateRunAutomataPage} /> */}
                <ProtectedRoute exact path="/completedRunAutomata" component={completedRunAutomata} />
                <ProtectedRoute exact path="/exceptionRunAutomata" component={ExceptionRunAutomata} />
                <ProtectedRoute exact path="/executionPerformance" component={ExecutionPerformance} />
                <ProtectedRoute exact path="/incidentManagement" component={IncidentManagement} />
                <ProtectedRoute exact path="/slaCompliance" component={SLACompliance} />
                <ProtectedRoute exact path="/queueEfficiency" component={QueueEfficiency} />
                <ProtectedRoute exact path="/analytics" workspace={workspace} component={Analytics} />
                <ProtectedRoute exact path="/queuePerformance" component={QueuePerformance} />
                <ProtectedRoute exact path="/alertManagement" component={AlertManagement} />
                <ProtectedRoute exact path="/SAPMonitoring" component={SAPMonitoring} workspace={workspace}/>
                <ProtectedRoute exact path="/SAPMonitoringThree" component={SAPMonitoringThree} workspace={workspace}/>
                <ProtectedRoute exact path="/bpmn" component={Bpmn} />
                
                <Route>
                <ProtectedRoute path="/manageSchedule" component={ManageSchedulePage} />
                <ProtectedRoute exact path="/addSchedule" component={CustomizedSteppers} />
                </Route>



            </div>
        </BrowserRouter> 
    );

}

export default Router;